var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttributeProjectValues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C9.20938 8 11 6.20937 11 4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4C3 6.20937 4.79063 8 7 8ZM9.8 9H9.27812C8.58437 9.31875 7.8125 9.5 7 9.5C6.1875 9.5 5.41875 9.31875 4.72188 9H4.2C1.88125 9 0 10.8813 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H10.0906C10.0156 15.7875 9.98438 15.5625 10.0094 15.3344L10.2219 13.4312L10.2594 13.0844L10.5063 12.8375L12.9219 10.4219C12.1562 9.55625 11.0469 9 9.8 9ZM11.2156 13.5406L11.0031 15.4469C10.9688 15.7656 11.2375 16.0344 11.5531 15.9969L13.4563 15.7844L17.7656 11.475L15.525 9.23438L11.2156 13.5406ZM19.7812 8.40312L18.5969 7.21875C18.3062 6.92812 17.8312 6.92812 17.5406 7.21875L16.3594 8.4L16.2313 8.52812L18.475 10.7688L19.7812 9.4625C20.0719 9.16875 20.0719 8.69687 19.7812 8.40312Z",
    fill: "#8F91A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeProjectValues);
export default __webpack_public_path__ + "static/media/attribute-project-values.749ca9a1.svg";
export { ForwardRef as ReactComponent };